// Axios client
import axios from "axios";

// Base URL (includes /api because backend uses context-path=/api)
const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8080/api";

const api = axios.create({
  baseURL,
  withCredentials: false, // JWT, no cookies
});

// Request interceptor
api.interceptors.request.use((config) => {
  // Check if endpoint is /auth
  const isAuthEndpoint =
    typeof config.url === "string" && config.url.startsWith("/auth");

  // Attach token if not auth endpoint
  if (!isAuthEndpoint) {
    const auth = JSON.parse(localStorage.getItem("auth") || "{}");
    if (auth?.token) {
      config.headers.Authorization = `Bearer ${auth.token}`;
    }
  } else {
    // Remove token for /auth endpoints
    if (config.headers?.Authorization) {
      delete config.headers.Authorization;
    }
  }

  // Default headers
  if (!config.headers["Accept"]) {
    config.headers["Accept"] = "application/json";
  }
  if (config.method !== "get" && !config.headers["Content-Type"]) {
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

api.interceptors.response.use((response) => {
  const method = response.config?.method?.toLowerCase();
  const url = response.config?.url || '';
  const actionType = method === 'post' ? 'create'
    : ['put', 'patch'].includes(method) ? 'update'
      : method === 'delete' ? 'delete'
        : null;

  if (actionType && !url.startsWith('/auth') && !url.includes('/import')) {
    window.dispatchEvent(new CustomEvent('app:mutation-success', { detail: { type: actionType } }));
  }

  return response;
});

export default api;
